<template>
  <div class="selected_all">
    <a-checkbox
      :checked="currentItem.isCheckAll"
      class="check-all"
      :disabled="!currentItem.platformInfo[`${currentPlatformType}_info`].list.length"
      @change="changeIsCheckAll">
      全选
    </a-checkbox>
  </div>
</template>

<script>
export default {
  props:{
    currentItem:{
      type:Object,
      default:()=>{return {}}
    },
    currentPlatformType:String
  },
  data() {
    return {}
  },
  methods:{
    changeIsCheckAll(e) {
      var isCheckAll = e.target.checked
      this.$emit('resetIsCheckAll',isCheckAll)
    }
  },
  mounted() {
  }
}
</script>

<style lang='less' scoped>
:deep(.check-all) {
  white-space: nowrap;
  border: 1px solid #ddd;
  padding: 4px 6px;
  border-radius: 3px;
  &.ant-checkbox-wrapper-checked {
    border-color: #007fff;
  }
}
</style>